var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148569",
    "data-name": "Rectangle 148569",
    width: 24,
    height: 24,
    transform: "translate(1749 150)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sorting",
    transform: "translate(-1749 -150)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11697",
    "data-name": "Group 11697",
    transform: "translate(2.048 2.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8819",
    "data-name": "Path 8819",
    d: "M137.417,22.425,140.4,19.44V35.989a.641.641,0,0,0,1.283,0V19.44l2.984,2.984a.646.646,0,0,0,.451.19.618.618,0,0,0,.451-.19.64.64,0,0,0,0-.908l-4.077-4.077a.649.649,0,0,0-.451-.19.621.621,0,0,0-.451.19l-4.077,4.077a.64.64,0,0,0,.9.908Z",
    transform: "translate(1613.007 132.912)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8820",
    "data-name": "Path 8820",
    d: "M137.417,31.456,140.4,34.44V17.891a.641.641,0,1,1,1.283,0V34.44l2.984-2.984a.646.646,0,0,1,.451-.19.618.618,0,0,1,.451.19.64.64,0,0,1,0,.908l-4.077,4.077a.649.649,0,0,1-.451.19.621.621,0,0,1-.451-.19l-4.077-4.077a.64.64,0,0,1,.9-.908Z",
    transform: "translate(1623.139 132.912)",
    fill: "#0c0c0b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortLarge);
export default __webpack_public_path__ + "static/media/sort-large.e9ae9b93.svg";
export { ForwardRef as ReactComponent };